function toutou_xy_sous_sol(myJson, zoom, ctx) {
    //Argument optionel
    if (zoom != null) var my_zoom = zoom;
    else var my_zoom = 0;
    // Donnees de MySQL
    var ni = myJson.hhh.length;
    var temp = new Array(ni);
    var ttdd = new Array(ni);
    var hhh = new Array(ni);
    var time_label = new Array(ni);
    var solaire = new Array(ni);
    var corr = new Array(ni);
    var message = new Array(ni);
    var color_code = new Array(ni);
    var aaaammjj = myJson.aaaammjj;
    var hh = myJson.hh;
    var datev = dateo;
    var my_fonts = new Toutou_Fonts();
    var tr = new Toutou_Transform();
    var thermo = new Toutou_Thermo();
    var td_critique = 0;
    var nptcub = 9;
    seuil_hr_Json = toutou_get_option('sous_sol_hr');
    //alert(seuil_hr_Json.valeur);
    seuil_tt_Json = toutou_get_option('sous_sol_tt');
    //alert(seuil_tt_Json.valeur);
    for(var i = 0; i < ni; i++){
        temp[i] = myJson.data1[i] * .01;
        ttdd[i] = temp[i] - myJson.data2[i] * .01;
        hhh[i] = myJson.hhh[i];
    }
    //solaire=jouleparm2_accumule_a_wattparm2(myJson.data4,hhh);
    //penetration_est=toutou_get_option('sous_sol_est');
    //penetration_sud=toutou_get_option('sous_sol_sud');
    //penetration_ouest=toutou_get_option('sous_sol_ouest');
    corr[0] = temp[0];
    for(var i = 1; i < ni; i++)//corr[i]=temp[i]+5.*Math.max(0.,solaire[i]/1000.);
    corr[i] = temp[i];
    pointsData['sous_sol'] = [];
    // Espace autour de la boite du graphique en %
    var pil_w = .08;
    var pil_e = .01;
    var pil_s = .35;
    var pil_n = .15;
    if (ctx == undefined) ctx = set_canvas('toutou_xy_sous_sol');
    tr.xrange(my_zoom, hhh);
    tr.ymin = ttdd.min();
    tr.ymax = corr.max();
    dimy = tr.ymax - tr.ymin;
    dimx = tr.xmax - tr.xmin;
    tr.xmin = tr.xmin - .02 * dimx;
    tr.xmax = tr.xmax + .02 * dimx;
    tr.ymin = tr.ymin - .02 * gxsize / gysize * dimy;
    tr.ymax = tr.ymax + .02 * gxsize / gysize * dimy;
    // Ajouter espace pour les bars de couleur
    dimy = tr.ymax - tr.ymin;
    tr.ymin = tr.ymin - .1 * dimy;
    incy = 1;
    nj = Math.floor(tr.ymax) - Math.ceil(tr.ymin) + 1;
    if (nj > 12) incy = 2;
    if (nj > 24) incy = 5;
    tr.ymax = Math.floor(tr.ymax);
    tr.ymax = tr.ymax + (incy - tr.ymax % incy);
    tr.ymin = Math.ceil(tr.ymin);
    tr.ymin = tr.ymin - (tr.ymin % incy + incy);
    tr.ymin = tr.ymin - Math.abs(tr.ymin % incy);
    nj = Math.floor(tr.ymax) - Math.ceil(tr.ymin) + 1;
    tr.pix_margeg = Math.round(pil_w * gxsize) + .5;
    tr.pix_marged = Math.round((1. - pil_e) * gxsize) + .5;
    tr.pix_margeh = Math.round(pil_n * gysize) + .5;
    tr.pix_margeb = Math.round((1. - pil_s) * gysize) + .5;
    tr.init(my_zoom);
    pointsData['sous_sol_params'] = {
        xmin_pix: tr.d2px(tr.xmin),
        xmax_pix: tr.d2px(tr.xmax),
        ymin_pix: tr.d2py(tr.ymin),
        ymax_pix: tr.d2py(tr.ymax),
        tt_col: 'blue',
        td_col: 'green',
        td_critique_col: 'orange'
    };
    hauteur = (tr.ymax_pix - tr.ymin_pix) * .066;
    hauteurh = (tr.ymax_pix - tr.ymin_pix) * .034;
    ctx.fillStyle = '#FFF';
    ctx.fillRect(0, 0, gxsize, gysize);
    tr.draw_model_zones(ctx, my_fonts, hhh, myJson.modele);
    // Titre principal
    ctx.font = my_fonts.principal;
    ctx.fillStyle = "#33A";
    ctx.textAlign = "center";
    ctx.textBaseline = "top";
    ctx.fillText('Date de depart : ' + toutou_xy_titre_principal(dateo), .5 * (tr.xmax_pix + tr.xmin_pix), 0);
    ctx.restore();
    // Titre secondaire
    ctx.font = my_fonts.legende;
    ctx.fillStyle = "blue";
    ctx.textAlign = "left";
    ctx.textBaseline = "bottom";
    ctx.fillText('En bleu : temperature [C]', tr.xmin_pix, tr.ymax_pix - 2);
    ctx.textAlign = "right";
    ctx.fillStyle = "green";
    ctx.fillText('En vert : point de rosee [C]', tr.xmax_pix, tr.ymax_pix - 2);
    // xticks
    tr.xticks_jours(datev, hhh, ctx, my_fonts, my_zoom, {
        time_label
    });
    // yticks
    ctx.beginPath();
    ctx.font = my_fonts.axis;
    ctx.fillStyle = "Black";
    nj = Math.floor(tr.ymax) - Math.ceil(tr.ymin) + 1;
    ctx.strokeStyle = 'black';
    ctx.textAlign = "right";
    ctx.textBaseline = "middle";
    xx = Math.round(tr.xmin_pix - .01 * (tr.xmax_pix - tr.xmin_pix)) + .5;
    for(var i = 0; i < nj; i = i + incy){
        yy = Math.round(tr.d2py(Math.ceil(tr.ymin) + i)) + .5;
        ctx.moveTo(tr.xmin_pix, yy);
        ctx.lineTo(xx, yy);
        ctx.fillText(Math.ceil(tr.ymin) + i + ' ', xx, yy);
    }
    ctx.stroke();
    // Lignes grises
    for(var i = 0; i < nj; i = i + incy){
        val = Math.ceil(tr.ymin) + i;
        yy = Math.round(tr.d2py(val)) + .5;
        ctx.beginPath();
        ctx.strokeStyle = '#bbb';
        // Ligne rouge a 0C et 30C
        if (val == 0 | val == 30) ctx.strokeStyle = '#f00';
        ctx.moveTo(tr.xmin_pix, yy);
        ctx.lineTo(tr.xmax_pix, yy);
        ctx.stroke();
    }
    // Tracer le code de couleur selon la temperature et l'humidite.
    // Note, td critique ne depend pas de la pression bien que l'interface
    // de shraes de demande. On passe donc la pression normale TPN.
    td_critique = seuil_tt_Json.valeur - thermo.shraes(seuil_hr_Json.valeur * .01, seuil_tt_Json.valeur + thermo.tcdk, 100130, 0, 0, 1, 1);
    ctx.beginPath();
    ctx.strokeStyle = 'orange';
    yy = tr.d2py(td_critique);
    ctx.moveTo(tr.xmin_pix, yy);
    ctx.moveTo(tr.xmin_pix, yy);
    ctx.lineTo(tr.xmax_pix, yy);
    ctx.stroke();
    for(i = 0; i < ni; i++){
        // Calcul du point de rosee avec les parametres de l'usage
        message[i] = 'Pas de message';
        color_code[i] = 'yellow';
        xx = tr.d2px(hhh[i]);
        if (i == 0) xxm = tr.pix_margeg;
        else xxm = xxp;
        if (i == ni - 1) xxp = tr.pix_marged;
        else xxp = .5 * (tr.d2px(hhh[i]) + tr.d2px(hhh[i + 1]));
        // Pour zoom
        xxp = Math.max(xxp, tr.pix_margeg);
        dx = Math.ceil(xxp - xxm);
        if (td_critique > ttdd[i]) {
            if (corr[i] >= seuil_tt_Json.valeur) {
                // Assez chaud pour ventiler et pas trop humide
                ctx.fillStyle = 'green';
                ctx.fillRect(Math.floor(xxm), tr.ymin_pix, dx, hauteurh + hauteur);
                message[i] = "Vous pouvez ventiler";
                color_code[i] = 'green';
            } else {
                // Trop froid pour ventiler bien que pas trop humide
                ctx.fillStyle = 'red';
                ctx.fillRect(Math.floor(xxm), tr.ymin_pix + hauteurh, dx, hauteur);
                ctx.fillStyle = 'blue';
                ctx.fillRect(Math.floor(xxm), tr.ymin_pix, dx, hauteurh);
                message[i] = "Trop froid pour ventiler, seuil " + seuil_tt_Json.valeur + " C";
                color_code[i] = 'red';
            }
        } else {
            // Trop humide pour ventiler
            ctx.fillStyle = 'red';
            ctx.fillRect(Math.floor(xxm), tr.ymin_pix + hauteurh, dx, hauteur);
            ctx.fillStyle = 'orange';
            ctx.fillRect(Math.floor(xxm), tr.ymin_pix, dx, hauteurh);
            message[i] = "Trop humide pour ventiler, seuil " + seuil_hr_Json.valeur + " %";
            color_code[i] = 'red';
        }
    }
    // Tracer la legende
    dx = .05 * (tr.pix_marged - tr.pix_margeg);
    ctx.fillStyle = 'red';
    xx = tr.pix_margeg;
    yy = tr.pix_margeb - 5.5 * hauteur;
    ctx.fillRect(xx, yy, dx, hauteur);
    ctx.font = my_fonts.legende;
    ctx.fillStyle = "black";
    ctx.textAlign = "left";
    ctx.textBaseline = "bottom";
    ctx.fillText(' Vous ne pouvez pas ventiler le sous-sol car :', xx + dx, yy);
    yy = yy - hauteur;
    ctx.fillStyle = 'blue';
    ctx.fillRect(xx + .5 * dx, yy, dx, hauteurh);
    ctx.fillStyle = "black";
    ctx.fillText(' temperature exterieure trop basse (seuil ' + seuil_tt_Json.valeur + ' C);', xx + 1.5 * dx, yy);
    yy = yy - hauteur;
    ctx.fillStyle = 'orange';
    ctx.fillRect(xx + .5 * dx, yy, dx, hauteurh);
    ctx.fillStyle = "black";
    ctx.fillText(' humidite exterieure trop grande (seuil ' + seuil_hr_Json.valeur + " %), point de ros\xe9 critique : " + td_critique.toFixed(1) + ' C;', xx + 1.5 * dx, yy);
    yy = yy - 1.5 * hauteur;
    ctx.fillStyle = 'green';
    ctx.fillRect(xx, yy, dx, hauteur);
    ctx.fillStyle = "black";
    ctx.fillText(' Vous pouvez ventiler le sous-sol.', xx + dx, yy);
    // Ecrire les opions choisies
    ctx.fillStyle = 'black';
    xx = tr.pix_margeg + .5 * (tr.pix_marged - tr.pix_margeg);
    ctx.font = my_fonts.legende;
    ctx.fillStyle = "black";
    ctx.textAlign = "left";
    ctx.textBaseline = "bottom";
    yy = tr.pix_margeb - 6 * hauteur;
    //ctx.fillText("Penetration du soleil dans la maison (cliquez sur option) :",xx,yy);
    //yy=yy-1.2*hauteur;
    //ctx.fillText('      Cote est     : '+penetration_est.valeur,xx,yy);
    //yy=yy-1.2*hauteur;
    //ctx.fillText('      Cote sud    : '+penetration_sud.valeur,xx,yy);
    //yy=yy-1.2*hauteur;
    //ctx.fillText('      Cote ouest : '+penetration_ouest.valeur,xx,yy);
    // Tracer la courbe de Td
    ctx.beginPath();
    ctx.fillStyle = pointsData['sous_sol_params'].td_col;
    ctx.strokeStyle = pointsData['sous_sol_params'].td_col;
    ctx.moveTo(tr.d2px(hhh[tr.xind_min]), tr.d2py(ttdd[tr.xind_min]));
    for(var i = tr.xind_min; i <= tr.xind_max; i++){
        xx = tr.d2px(hhh[i]);
        yy = tr.d2py(ttdd[i]);
        //ctx.lineTo(xx,yy);
        ctx.fillRect(xx - tr.dd, yy - tr.dd, 2 * tr.dd, 2 * tr.dd);
        pointsData['sous_sol'].push({
            x: xx,
            y: yy,
            tl: time_label[i],
            tt: temp[i],
            td: ttdd[i],
            message: message[i],
            color_code: color_code[i],
            td_critique: td_critique
        });
    }
    res = toutout_cubic_mono(hhh, ttdd, nptcub);
    for(i = tr.xind_min * (nptcub + 1); i <= tr.xind_max * (nptcub + 1); i++)ctx.lineTo(tr.d2px(res.x[i]), tr.d2py(res.y[i]));
    ctx.stroke();
    // Tracer T
    ctx.beginPath();
    ctx.fillStyle = pointsData['sous_sol_params'].tt_col;
    ctx.strokeStyle = pointsData['sous_sol_params'].tt_col;
    for(var i = tr.xind_min; i <= tr.xind_max; i++){
        xx = tr.d2px(hhh[i]);
        yy = tr.d2py(temp[i]);
        //ctx.lineTo(xx,yy);
        if (corr[i] > temp[i]) {
            ctx.strokeStyle = 'red';
            yy = tr.d2py(corr[i]);
            ctx.fillRect(xx - tr.dd, yy - tr.dd, 2 * tr.dd, 2 * tr.dd);
            ctx.moveTo(tr.d2px(hhh[i]), tr.d2py(temp[i]));
            ctx.lineTo(tr.d2px(hhh[i]), yy);
            ctx.stroke();
        }
        ctx.fillRect(xx - tr.dd, yy - tr.dd, 2 * tr.dd, 2 * tr.dd);
        pointsData['sous_sol'].push({
            x: xx,
            y: yy,
            tl: time_label[i],
            tt: temp[i],
            td: ttdd[i],
            message: message[i],
            color_code: color_code[i],
            td_critique: td_critique
        });
    }
    ctx.strokeStyle = 'blue';
    res = toutout_cubic_mono(hhh, temp, nptcub);
    for(i = tr.xind_min * (nptcub + 1); i <= tr.xind_max * (nptcub + 1); i++)ctx.lineTo(tr.d2px(res.x[i]), tr.d2py(res.y[i]));
    ctx.stroke();
}

//# sourceMappingURL=imeteo.02a5606f.js.map
